import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, FormGroup, Label, Row, Input, UncontrolledTooltip } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";

const AccountOwnerStockTradingRestriction = ({ nextStep, prevStep, active, processing, brokerDealerChecked, investAccount }) => {
    const [stockRestrictions, setStockRestrictions] = useState([]);
    let restrictionValue = useRef(null);

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            if (investAccount && investAccount.stock_restrictions) {
                setStockRestrictions(JSON.parse(investAccount.stock_restrictions));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const handleNext = () => {
        nextStep({ stock_restrictions: JSON.stringify(stockRestrictions) });
    };

    const _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            const value = e.target.value.trim();
            if (value && stockRestrictions.indexOf(value) === -1) {
                setStockRestrictions([...stockRestrictions, value]);
                restrictionValue.current.value = '';
            }
        }
    };

    const removeStockRestrictionItem = (index) => {
        if (stockRestrictions.length) {
            const tempValue = [...stockRestrictions];
            tempValue.splice(index, 1);
            setStockRestrictions(tempValue);
        }
    };

    const handleBack = () => {
        prevStep(brokerDealerChecked ? 0 : 1);
    };

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <div className="form-container">
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>PRIMARY ACCOUNT OWNER</h2>
                    <span>Do you have any stock trading restrictions?</span>
                </div>
                <div className="account-info-container">
                    <FormGroup>
                        <Row>
                            <Label sm={4}>Stock Restrictions</Label>
                            <div sm={1} xs={2} className="d-flex align-items-center">
                                <span id="stock-restriction-tooltip">
                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                </span>
                                <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="stock-restriction-tooltip">
                                    You might restrict certain stocks if you work for a public company and have access to confidential information,
                                    or if you prefer not to trade the stocks of certain companies as part of a socially-responsible investing strategy.
                                    <br /><br />
                                    Important:<br />
                                    (+) We can't prevent the purchase of stocks within an ETF.<br />
                                    (+) We don't buy or sell restricted stocks. If you add a stock to your restricted list that is already in your portfolio, we continue to hold it indefinitely.<br />
                                    (+) Stock restrictions may impact your portfolio's performance compared to portfolios without such restrictions.
                                </UncontrolledTooltip>
                            </div>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <Input
                                    innerRef={restrictionValue}
                                    type="text"
                                    onKeyDown={_handleKeyDown}
                                    name="primary_account_owner_date_of_birth"
                                    placeholder="Enter symbol or company name" />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm={12}>
                                <ul className="restriction-list">
                                    {!!stockRestrictions.length && stockRestrictions.map((restriction, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{restriction}</span>
                                                <button onClick={() => removeStockRestrictionItem(index)}>X</button>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Col>
                        </Row>
                    </FormGroup>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="button" onClick={handleNext} disabled={processing}>
                        NEXT STEP {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </div>
        </div>
    )
};

export default reduxForm({
    form: 'AccountOwnerStockTradingRestrictionForm',
})(AccountOwnerStockTradingRestriction);
